<template>
	<div class="product-right">
		<!-- 只有一个 -->
		<div class="product-div flex_ju_c one" v-if="data.length == 1">
			<div class="flex flex_a_c center divs">
				<div class="flex flex_a_c">
					<img class="product-icon" :src="makeIcons(data[0].itemCode)" alt="" />
					<div>
						<div class="product-word">{{ data[0]['itemName'] }}</div>
						<div class="product-word">{{ data[0]['itemValue'] }}{{ data[0]['itemUnitCode'] }}</div>
					</div>
				</div>
				<img
					class="product-line center-line"
					:class="{ 'center-line-big': entLength == 1 }"
					src="@/assets/image/lines/right_center.png"
					alt=""
				/>
			</div>
		</div>
		<!-- 有两个 -->
		<div class="product-div flex_ju_sa two" v-else-if="data.length == 2">
			<div class="flex divs" v-for="(item, index) in data" :key="index">
				<div class="flex flex_a_c">
					<img class="product-icon" :src="makeIcons(item.itemCode)" alt="" />
					<div>
						<div class="product-word">{{ item.itemName }}</div>
						<div class="product-word">{{ item.itemValue }}{{ item.itemUnitCode }}</div>
					</div>
				</div>
				<img v-if="index == 0" class="product-line twotop-line" src="@/assets/image/lines/right_top.png" alt="" />
				<img v-else-if="index == 1" class="product-line twobot-line" src="@/assets/image/lines/right_bot.png" alt="" />
			</div>
		</div>
		<!-- 有三个 -->
		<div class="product-div flex_ju_sa three" v-else-if="data.length == 3">
			<div class="flex divs" v-for="(item, index) in data" :key="index">
				<div class="flex flex_a_c">
					<img class="product-icon" :src="makeIcons(item.itemCode)" alt="" />
					<div>
						<div class="product-word">{{ item.itemName }}</div>
						<div class="product-word">{{ item.itemValue }}{{ item.itemUnitCode }}</div>
					</div>
				</div>
				<img v-if="index == 0" class="product-line twotop-line" src="@/assets/image/lines/right_top.png" alt="" />
				<img
					v-else-if="index == 1"
					class="product-line center-line"
					src="@/assets/image/lines/right_center.png"
					alt=""
				/>
				<img v-else-if="index == 2" class="product-line twobot-line" src="@/assets/image/lines/right_bot.png" alt="" />
			</div>
		</div>
		<div class="product-div flex_ju_sa four" v-else-if="data.length == 4">
			<div class="flex divs" v-for="(item, index) in data" :key="index">
				<img v-if="index == 0" class="product-line top-line" src="@/assets/image/lines/right_top.png" alt="" />
				<img
					v-else-if="index == 1"
					class="product-line center-line"
					src="@/assets/image/lines/right_center.png"
					alt=""
				/>
				<img v-else-if="index == 2" class="product-line bot-line" src="@/assets/image/lines/right_bot.png" alt="" />
				<img v-else-if="index == 3" class="product-line botb-line" src="@/assets/image/lines/right_botb.png" alt="" />
				<div class="flex flex_a_c">
					<img class="product-icon" :src="makeIcons(item.itemCode)" alt="" />
					<div>
						<div class="product-word">{{ item.itemName }}</div>
						<div class="product-word">{{ item.itemValue }}{{ item.itemUnitCode }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { icons } from '@/assets/json/qxicon'
import { iconList } from '@/assets/json/img'
// 生产监测-环境监测右数据
export default {
	props: {
		data: {
			type: Array,
			default: () => {
				return []
			},
		},
		entLength: {
			type: [String, Number],
			default: 0,
		},
	},
	methods: {
		makeIcons(code) {
			// // 先判断一个
			// if (icons[code]) {
			// 	return icons[code]
			// } else {
			// 	// 查询iconList里面是否有这个
			// 	let iconIndex = iconList.findIndex((item) => {
			// 		return item.key == code
			// 	})
			// 	// 有，取值
			// 	if (iconIndex > -1) {
			// 		return iconList[iconIndex]['path']
			// 	} else {
			// 		// 没有，查询是否包含
			// 		let iconIndexTwo = iconList.findIndex((item) => {
			// 			return code.indexOf(item.key) > -1 || item.key.indexOf(code) > -1
			// 		})
			// 		if (iconIndexTwo > -1) {
			// 			return iconList[iconIndexTwo]['path']
			// 		} else {
			// 			return require('@/assets/image/qx/icon_yw.png')
			// 		}
			// 	}
			// }
			return require(`@/assets/image/lastData/${this.getImgByCode(code)}.png`) 
		},
		getImgByCode(code) {
			let appIcon
			switch (code) {
				case 'WD':
				case 'KQWD':
				case 'KW':
				case 'DQWD':
					appIcon = 'KQWD'
					break
				case 'KQSD':
				case 'SD':
				case 'KS':
				case 'DQSD':
					appIcon = 'KQSD'
					break
				case 'TW':
				case 'TRWD':
					appIcon = 'TRWD'
					break
				case 'TS':
				case 'TRSD':
					appIcon = 'TRSD'
					break
				case 'FS':
					appIcon = 'FS'
					break
				case 'FX':
					appIcon = 'FX'
					break
				case 'KGD':
				case 'GZQD':
				case 'GZ':
				case 'ZD':
					appIcon = 'GZD'
					break
				case 'ZY':
					appIcon = 'ZY'
					break
				case 'PM25':
					appIcon = 'PM25'
					break
				case 'PM10':
					appIcon = 'PM10'
					break
				case 'DQYL':
				case 'SZQY':
					appIcon = 'DQYL'
					break
				case 'YL':
				case 'FZYL':
				case 'YLLJ':
					appIcon = 'YL'
					break
				case 'RJYL':
				case 'YLLJ':
					appIcon = 'RJYL'
					break
				case 'CO2':
				case 'EYHT':
					appIcon = 'CO2'
					break
				case 'YQ':
					appIcon = 'YQ'
					break
				case 'TYZFS':
				case 'GHYXFS':
				case 'ZWFS':
				case 'TYZFS':
				case 'FSLJ':
					appIcon = 'TYFS'
					break
				case 'SYDL':
					appIcon = 'SYDL'
					break
				case 'GL':
				case 'ZGL':
				case 'FZGL':
				case 'AXGL':
				case 'BXGL':
				case 'CXGL':
					appIcon = 'FZGL'
					break
				case 'TEC':
				case 'DDL':
					appIcon = 'TRDDL'
					break
				case 'TDHL':
				case 'DLZ':
					appIcon = 'DAN'
					break
				case 'TLHL':
				case 'LLZ':
					appIcon = 'LIN'
					break
				case 'TJHL':
				case 'JLZ':
					appIcon = 'JIA'
					break
				case 'TPH':
				case 'PH':
					appIcon = 'TRPH'
					break
				case 'DY':
				case 'AXDY':
				case 'BXDY':
				case 'CXDY':
					appIcon = 'DY'
					break
				case 'DL':
				case 'AXDL':
				case 'BXDL':
				case 'CXDL':
					appIcon = 'DL'
					break
				case 'DN':
				case 'ZDN':
				case 'AXDN':
				case 'BXDN':
				case 'CXDN':
					appIcon = 'DN'
					break
				case 'SW':
					appIcon = 'SW'
					break
				case 'SPH':
					appIcon = 'SPH'
					break
				case 'RJYQ':
					appIcon = 'RJYQ'
					break
				case 'XSSSLL':
				case 'SSSLL':
				case 'LJLL':
					appIcon = 'XSSSLL'
					break
				case 'AQ':
					appIcon = 'AQ'
					break
				case 'LHQ':
					appIcon = 'LHQ'
					break
				case 'LDWD':
					appIcon = 'LDWD'
					break
				case 'YW':
					appIcon = 'YW'
					break
				case 'ZF':
					appIcon = 'ZF'
					break
				default:
					appIcon = 'errimg'
					break
			}
			return appIcon
		},
	},
}
</script>

<style lang="scss" scoped>
.product-right {
	.product-div {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.product-icon {
		width: 0.5rem;
		height: 0.5rem;
		margin-right: 0.19rem;
	}
	.product-word {
		font-family: 'Source Han Sans CN';
		font-size: 0.2rem;
		color: #2daea9;
		padding: 0.05rem 0;
		&:nth-child(2) {
			text-align: left;
		}
	}
	.divs {
		position: relative;
	}
	.product-line {
		position: absolute;
		top: 0;
		right: 1.69rem;
		width: 2.26rem;
		height: auto;
	}
	.one {
		.center-line {
			top: 0.18rem;
		}
		.center-line-big {
			width: 2.88rem;
		}
	}

	.two {
		.twotop-line {
			top: 0.25rem;
		}
		.twobot-line {
			top: -0.4rem;
			width: 2.88rem;
		}
	}
	.three {
		.center-line {
			height: 0.13rem;
			top: 0.25rem;
		}
		.twotop-line {
			top: 0.25rem;
		}
		.twobot-line {
			width: 3.21rem;
			top: -0.6rem;
		}
	}
	.four {
		.top-line {
			width: 2.81rem;
			top: 0.3rem;
		}
		.center-line {
			top: 0.3rem;
		}
		.bot-line {
			top: -0.28rem;
		}
		.botb-line {
			width: 2.63rem;
			top: -0.69rem;
		}
	}
}
</style>
